module.exports = __webpack_public_path__ + "static/media/genres.50774a79.png";